import React, { useState, useReducer, createContext, useContext, useEffect } from 'react';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message } from 'antd';
import "./index.less";
import { classifyList, sloganAdd, sloganUpdate, sloganList, sloganStatust, selectSloganList, linkList, editLinks, linkDetail, linkDelete } from "../../api";
const { Option } = Select;
const Ctx = createContext();

const initInfo = {
    firstClassifyChooseId: '',
    recommendWords: '',
    delStatus: '',
    url: '',
    id: null,
}
const reducer = (state, action) => {
    return { ...state, ...action };
}

const recommendStatus = ['启用', '停用'];

//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info, isModify }, dispatch } = useContext(Ctx);
    const [selectSloganListData, setSelectSloganListData] = useState([])
    const [delStatus, setDelStatus] = useState(info.delStatus)
    console.log(info.delStatus)
    useEffect(() => {
        if (isModify) {
            setDelStatus(info.delStatus)
        } else {
            setDelStatus(info.delStatus + '')
        }

    }, [info.delStatus, isModify])
    const handleOk = async () => {
        let res;
        const params = {
            id: isModify ? null : info.id,
            recommendWords: info.recommendWords,
            delStatus: delStatus,
            url: info.url
        }
        if (info.recommendWords == '') {
            message.error('请输入友情链接名称!')
            return
        }
        if (info.url == '') {
            message.error('请输入url!')
            return
        }
        if (info.delStatus == null) {
            message.error('请选择是否启用!')
            return
        }
        res = await editLinks({ ...params });
        if (res?.error?.errorCode == 0) {
            dispatch({ isModalVisible: false, success: true });
            if (isModify) {
                message.success('新增成功!');
                setDelStatus(null)
            } else {
                message.success('修改成功!');
            }

        } else {
            message.error(res?.error?.errorMsg);
        }
    };

    const handleCancel = () => {
        dispatch({ isModalVisible: false });
        if (isModify) {
            dispatch({
                info: {
                    ...info,
                    recommendWords: '',
                    url: '',
                    id: null,
                    delStatus: null
                }
            })
        }
    };

    // 状态修改
    const handleChangeDelStatus = value => {
        setDelStatus(value)//显示标语
        dispatch({ info: { ...info, delStatus: value } })
    };
    return (
        <Modal visible={isModalVisible} wrapClassName='classify_yunying_modal' onOk={handleOk} title={isModify ? '新增' : '编辑'} onCancel={handleCancel} footer={[
            <Button key="submit" type="primary" onClick={handleOk}>
                确认
            </Button>, <Button key="submit" type="primary" onClick={handleCancel}>
                取消
            </Button>
        ]}>
            <>
                <div className='form_item'>
                    <span className='form_item_label'>友情链接：</span>
                    <Input className='form_item_input' placeholder="请输入友情链接名称" value={info.recommendWords} onChange={e => dispatch({ info: { ...info, recommendWords: e.target.value } })} />
                </div>
                <div className='form_item'>
                    <span className='form_item_label'>url：</span>
                    <Input className='form_item_input' placeholder="请输入url" value={info.url} onChange={e => dispatch({ info: { ...info, url: e.target.value } })} />
                </div>
                <div className='form_item'>
                    <span className='form_item_label'>状态：</span>
                    {/* <Input className='form_item_input' placeholder="请输入标语" value={info.delStatus} onChange={e => dispatch({ info: { ...info, slogan: e.target.value } })} /> */}
                    <Select value={delStatus} style={{ width: 372 }} onChange={handleChangeDelStatus}>
                        <Option value='0' key={0}>启用</Option>
                        <Option value='1' key={1}>停用</Option>
                    </Select>
                </div>
            </>

        </Modal>
    )
}
// 父组件 最外层
function LinkUrlManage() {
    const [delStatus, setDelStatus] = useState(null);//一级分类默认选中
    const [listLoading, setListLoading] = useState(false)
    const [secondClassifyList, setSecondClassifyList] = useState([]);
    const [recommendkeysList, setRecommendkeysList] = useState([]);
    const [recommendKey, setRecommendKey] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(1);

    const [state, dispatch] = useReducer(reducer, {
        isModify: true, isModalVisible: false, info: initInfo, success: false
    });
    useEffect(() => {
        getLinkList(null, '', 1);
    }, [])

    useEffect(() => {
        if (state.success) {
            getLinkList(null, '', page);
            dispatch({ success: false })
        }
    }, [state.success]);
    const columns = [
        {
            title: "序号",
            width: '8%',
            render: (text, record, index) => index + 1
        },
        {
            title: '友情链接名称',
            dataIndex: 'recommendWords',
            width: '20%'
        },
        {
            title: 'URL',
            dataIndex: 'url',
            width: '12%',
        },
        {
            title: '状态',
            dataIndex: 'delStatus',
            width: '10%',
            // sorter: (a, b) => a.delStatus > b.delStatus ? 1 : -1,
            // sorter: true,
            render: (v) => {
                return (
                    <span>{recommendStatus[v]}</span>
                )
            }
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '12%',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (v, r) => {
                return (
                    <>
                        {r.delStatus == 0
                            ? <Button onClick={() => updateStatus(r, 1)}>停用</Button> : <Button onClick={() => updateStatus(r, 0)}>启用</Button>}
                        <Button onClick={() => modify(r)}>编辑</Button>
                        <Button onClick={() => deleteData(r)}>删除</Button>
                    </>
                )
            },
        }
    ]
    // 编辑带入当前列表的数据填充
    const modify = record => {
        linkDetail(record.id).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                dispatch({
                    isModalVisible: true, isModify: false,
                    info: {
                        ...state.info, recommendWords: res?.data?.recommendWords,
                        delStatus: res?.data?.delStatus,
                        url: res?.data?.url,
                        id: res?.data?.id
                    }
                });
            }

        })

    }
    // 删除列表数据
    const deleteData = record => {
        linkDelete(record?.id).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                message.info('已删除')
                getLinkList(delStatus, '', page);
            }
        })
    }
    // 启用，停用接口
    const updateStatus = async (record, clickdelStatusType) => {
        const res = await editLinks({
            id: record.id,
            recommendWords: record.recommendWords,
            delStatus: clickdelStatusType,
            url: record.url
        });
        if (res?.error?.errorCode == 0) {
            getLinkList(delStatus != null ? (delStatus ) : null, '', page);
        }
    }

    // 获取标语列表 渲染表格
    const getLinkList = (delStatusType, recommendKeys, page) => {
        setListLoading(true)
        linkList({
            delStatus: delStatusType == 2 ? null : delStatusType,
            page: page,
            pageSize: 10,
            recommendWords: recommendKeys,
        }).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                setRecommendkeysList(res?.data?.contents)

                setTotal(res?.data?.total)
            } else {
                setRecommendkeysList([])
            }
        }).finally(() => {
            setListLoading(false)
        })
    }

    // 一级分类change
    const handleChangeDelStatus = value => {
        setDelStatus(value);
    };

    const search = () => {
        setPage(1)
        getLinkList(delStatus, recommendKey, 1)
    }

    const addNewItem = () => {
        dispatch({ isModalVisible: true, isModify: true, info: { ...state.info, recommendWords: '', url: '', id: null, delStatus: null } });
    }

    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>友情链接管理</h2>
                <div className="myForm">
                    <div>
                        <span className="select_label">友情链接名称：</span>
                        <Input type={Number} style={{ width: 125 }} placeholder="请输入友情链接名称" value={recommendKey} onChange={(e) => {
                            setRecommendKey(e.target.value)
                        }} />
                    </div>

                    <div>
                        <span className="select_label">状态：</span>
                        <Select value={delStatus} style={{ width: 120 }} onChange={handleChangeDelStatus}>
                            <Option value={2} key={2}>全部</Option>
                            <Option value={0} key={0}>启用</Option>
                            <Option value={1} key={1}>停用</Option>
                        </Select>
                    </div>


                    <div>
                        <Button type="primary" onClick={search}>查询</Button>
                        <Button type="primary" onClick={addNewItem}>新增</Button>
                    </div>
                </div>

            </div>
            <div className="bottomTable">
                <Table
                    loading={listLoading}
                    columns={columns}
                    dataSource={recommendkeysList}
                    pagination={
                        {
                            total: total,
                            current: page,
                            onChange(page) {
                                console.log(page)
                                setPage(page)
                                getLinkList(delStatus, recommendKey, page)
                            },
                            pageSize: 10
                        }
                    }
                />
            </div>
            <Ctx.Provider value={{ state, dispatch }} >
                <EditModal isModalVisible={state.isModalVisible} />
            </Ctx.Provider>
        </div >
    )
}

export default LinkUrlManage;